import React from 'react'
import { faSearch, faUndo } from '@fortawesome/free-solid-svg-icons';
import ButtonIcon from 'components/ButtonComp';
import DrawerComp from 'components/Drawer'
import SelectComp from 'components/SelectComp'
import { check_status } from 'data/check_status';
import useForm from 'hooks/useForm';
import { IAssetBaseLine } from 'models/AssetBaseLine';
import { IAssetType } from 'models/AssetsTypes';

type Props = {
    assetTypes: IAssetType[];
    assetBaseLines: IAssetBaseLine[];
    hookForm: ReturnType<typeof useForm>;
}

const FiltersComp: React.FC<Props> = ({
    assetTypes,
    assetBaseLines,
    hookForm
}: Props) => {
    const restoreFilters = () => {
        hookForm.setForm({
            base_line_id: 'all',
            asset_type_id: 'all',
            check_status: 'all'
        });
    }

    return (
        <DrawerComp
            title='Filtros'
            placement='right'
            type='button'
            variant='outline-primary'
        >
            <SelectComp
                className='mb-4'
                title='Línea base'
                name='base_line_id'
                value={hookForm.form?.base_line_id}
                options={[{
                    label: 'Todas', value: 'all'
                },
                ...assetBaseLines.map(item => ({ label: item.name, value: item.id.toString() }))
                ]}
                onChange={hookForm.handleChange}
            />

            <SelectComp
                className='mb-4'
                title='Tipo de Activo'
                name='asset_type_id'
                value={hookForm.form?.asset_type_id}
                options={[{
                    label: 'Todos', value: 'all'
                },
                ...assetTypes.map(item => ({ label: item.name, value: item.id.toString() }))
                ]}
                onChange={hookForm.handleChange}
            />

            <SelectComp
                className='mb-4'
                title='Estado de Verificación'
                name='check_status'
                value={hookForm.form?.check_status}
                options={[{
                    label: 'Todos', value: 'all'
                },
                ...check_status.map(item => ({ label: item.value, value: item.value }))
                ]}
                onChange={hookForm.handleChange}
            />
            <div className="d-grid mt-4">
                <ButtonIcon name='Limpiar Filtros' icon={faUndo} variant='outline-secondary' onClick={restoreFilters} />
            </div>
            <div className="d-grid gap-2 mt-2">
                <ButtonIcon name='Buscar' icon={faSearch} variant='success' onClick={hookForm.updateParams} />
            </div>
        </DrawerComp>
    )
}

export default FiltersComp